import styles, { layout } from "../style";
import { LogoIcon } from "../assets";
import { Reveal } from "./reveal";

const Services = () => {
  return(
  <section className={`${styles.flexCenter} flex flex-col gap-20 py-40`}>
    <div className="flex flex-col gap-12 items-center w-full">
      <Reveal>
      <h1 className="text-center font-semibold xs:text-mm text-sm leading-[30px] xs:leading-[50px] xs:max-w-[640px] max-w-[400px]">
        Unlocking Scalable Value in the Creator Economy 2026
      </h1>
      </Reveal>

      <Reveal>
        <p className={`xs:text-sm text-ss xs:max-w-[470px] max-w-[360px] mt-5 text-center`}>
          The cultural and creative industries (CCI) on the continent are undergoing a structural invigoration driven by shifts in technology, consumer behavior, and global market dynamics. We believe this presents a generational opportunity to invest in platforms, infrastructure, and ventures that empower creators, rebalance value chains, and scale cultural innovation, as well as back creators and players who unlock new forms of value, redistribute power in the digital economy, and build systems that honor creative labor.
        </p>
      </Reveal>
    </div>    
    

    <div className="flex flex-col items-center gap-20 w-full ">
      <Reveal>
        <p className={`xs:text-sm text-ss max-w-[470px] px-10 text-center ${styles.flexCenter}`}>
          We invest in ventures, creators and spaces that nurture the creative class—designers, artists, and intellectual workers through education, tooling, and community.
        </p>
      </Reveal>
      <div className="flex flex-row gap-4 items-center">
        <span className="border-b border-1 border-second w-[200px]"></span>
        <img
          src={LogoIcon}
          alt="HSL"
          className="w-[50px] h-[50px] object-contain"
        />
        <span className="border-b border-1 border-second w-[200px]"></span>
      </div>
      <Reveal>
        <p className={`xs:text-sm text-ss xs:max-w-[470px] max-w-[360px] mt-5 text-center`}>
          We back founders who live the problems they solve. We believe that deep founder market fit, combined with
          cultural fluency and execution excellence, is the single greatest predictor of success. AfriNext Ventures is
          committed to providing the capital, community, and strategic support to help these builders define Africa's
          digital and creative future
        </p>
      </Reveal>
    </div>               
  </section>
)};

export default Services;